import { ReactNode, useRef } from "react";

import { Box } from "@mui/material";
import { useInfiniteScroll } from "../../hooks/useInfiniteScroll";

interface InfiniteScrollWrapperProps {
  children?: ReactNode;
  lastEvaluatedKey?: string | null;
  loading?: boolean;
  fetchNextPage: () => void;
}

const InfiniteScrollWrapper = ({
  children,
  lastEvaluatedKey,
  loading = false,
  fetchNextPage,
}: InfiniteScrollWrapperProps) => {
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  useInfiniteScroll(sentinelRef, fetchNextPage, !!lastEvaluatedKey, loading);

  return (
    <>
      {children}
      {!!lastEvaluatedKey && <Box ref={sentinelRef} sx={{ height: "1px" }} />}
    </>
  );
};

export default InfiniteScrollWrapper;
